import { FlightState, TypeFlight } from "@/lib/redux/features/flight/type"

export const byRangeTime = (state: FlightState, flight: TypeFlight) => {
  const rangeTimes = Object.values(state.flightsResult.filters.rangeTimes || [])
  if (rangeTimes.length <= 0) {
    return true
  }
  return rangeTimes.indexOf(flight?.rangeTime || '') > -1
}